import { WorkingHoursContractRepository } from '../domain/WorkingHoursContractRepository';
import { WorkingHoursContractScreenData } from '../domain/WorkingHoursContractScreenData';

export class WorkingHoursContractComponent {
  working_hours_contract_repo: WorkingHoursContractRepository;
  screen_data: WorkingHoursContractScreenData;

  constructor(working_hours_contract_repo, screen_data) {
    this.working_hours_contract_repo = working_hours_contract_repo;
    this.screen_data = screen_data;
  }

  async activateWorkingHoursTrialContract(user_id: number, company_id: number, product_code='INM5F', kind='working_hours') {
    this.screen_data.setLoading(true);
    let res = await this.working_hours_contract_repo.activate_trial_working_hours_contract(user_id, company_id, product_code, kind);
    this.screen_data.setLoading(false);
    return res;
  }

  async checkWorkingHoursContractShowTrial(user_id: number, company_id: number) {
    let res = await this.working_hours_contract_repo.check_user_working_hours_active_contract(user_id, company_id);
    this.screen_data.setShowTrial(!res.has_active);
    return res;
  }
}